<template>
  <div class="wallet-skeleton">
    <div class="skeleton-pill wp-skeleton"></div>
    <div class="skeleton-pill token-skeleton"></div>
    <div class="skeleton-wallet"></div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'WalletSkeleton' })
</script>

<style scoped lang="scss">
.wallet-skeleton {
  display: flex;
  align-items: center;
  gap: 8px;

  @include mobile {
    gap: 4px;
  }

  .skeleton-pill {
    height: 32px;
    border-radius: 16px;
    background: linear-gradient(90deg, rgba($elevation1, 0.6) 25%, rgba($elevation2, 0.4) 50%, rgba($elevation1, 0.6) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;

    &.wp-skeleton {
      width: 80px;
    }

    &.token-skeleton {
      width: 70px;

      @include mobile {
        display: none;
      }
    }
  }

  .skeleton-wallet {
    height: 40px;
    width: 120px;
    border-radius: 8px;
    background: linear-gradient(90deg, rgba($elevation1, 0.6) 25%, rgba($elevation2, 0.4) 50%, rgba($elevation1, 0.6) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;

    @include mobile {
      width: 100px;
      height: 36px;
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
}
</style>